import { render, staticRenderFns } from "./ExpertTermsRemindersTable.vue?vue&type=template&id=761a9611&scoped=true"
import script from "./ExpertTermsRemindersTable.vue?vue&type=script&lang=js"
export * from "./ExpertTermsRemindersTable.vue?vue&type=script&lang=js"
import style0 from "./ExpertTermsRemindersTable.vue?vue&type=style&index=0&id=761a9611&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761a9611",
  null
  
)

export default component.exports